import React from 'react';

function AboutPage() {
  return (
    <div className="container mx-auto p-4 max-w-4xl">
      {/* Header */}
      <h1 className="text-3xl font-bold text-center mb-8">Acerca de Dichos de la Abuela</h1>
      
      {/* Introduction paragraph */}
      <div className="mb-12">
        <p className="text-lg leading-relaxed text-gray-700">
          Los dichos tienen una forma especial de quedarse en nuestra memoria. En nuestra familia, han sido una constante, 
          siempre presentes en las conversaciones y consejos de nuestra madre y abuela. Nhora es una mujer de 86 años con una 
          energía inquebrable; aún recuerdo verla trabajando en la finca cuando los trabajadores no estaban, cargando bultos de 40 
          kg.
        </p>
      </div>

      {/* Our History Section */}
      <div className="mb-12">
        <h2 className="text-2xl font-bold mb-6">Nuestra Historia</h2>
        
        {/* First photo of the elderly lady */}
        <div className="flex justify-center mb-8">
          <img 
            src="/photos/abuela3.png" 
            alt="Señora en el restaurante junto al mar" 
            className="max-w-full h-auto rounded-lg shadow-lg"
            style={{ maxHeight: '400px', objectFit: 'cover' }}
          />
        </div>
        
        <p className="text-lg leading-relaxed text-gray-700 mb-8">
          A lo largo de su vida, Nhora ha acumulado más de 600 dichos que reflejan su forma de ver el mundo. Algunos nos han 
          hecho reír, otros nos han dado perspectiva, pero todos llevan consigo un poco de su esencia.
        </p>
        
        <p className="text-lg leading-relaxed text-gray-700">
          Este sitio es un espacio para compartir ese legado de frases que han marcado generaciones. Bienvenidos a 
          dichosdelaabuela.com, donde las palabras tienen historia.
        </p>
      </div>

      {/* Share Your Story Section */}
      <div className="mb-12">
        <h2 className="text-2xl font-bold mb-6">Comparte tu historia</h2>
        
        {/* Second photo of the elderly lady */}
        <div className="flex justify-center mb-8">
          <img 
            src="/photos/abuela.png" 
            alt="Señora en el jardín con flores" 
            className="max-w-full h-auto rounded-lg shadow-lg"
            style={{ maxHeight: '400px', objectFit: 'cover' }}
          />
        </div>
        
        <p className="text-lg leading-relaxed text-gray-700">
          Los dichos de la abuela tienen una magia especial: nos enseñan, nos hacen reír y nos acompañan en los momentos 
          clave de la vida. ¿Tienes una frase que siempre escuchabas en casa? ¿Un dicho que te marcó o aún repites? 
          Nos encantaría conocerte. Comparte con nosotros ese pequeño tesoro de sabiduría que has pasado de generación en 
          generación. Si son un consejo, una advertencia o simplemente una frase llena de cariño, todos tienen su lugar aquí. 
          Déjanos tu dicho y su historia, porque en dichosdelaabuela.com, las palabras siguen vivas.
        </p>

        {/* Third photo of the elderly lady */}
        <div className="flex justify-center mb-8">
          <img 
            src="/photos/abuela4.png" 
            alt="Señora en un centro comercial" 
            className="max-w-full h-auto rounded-lg shadow-lg"
            style={{ maxHeight: '400px', objectFit: 'cover' }}
          />
        </div>
      </div>
    </div>
  );
}

export default AboutPage; 